import api from '../../api/index';
import dayjs from 'dayjs';
import utc from 'dayjs-plugin-utc';
import i18n from '../../i18n';

dayjs.extend(utc);
const user_factory=(name, family, patronymic, phone_number, birth_date, additional)=>{
  return {
    name, last_name  : family, second_name: patronymic, phone_number, birth_date, additional,
  };
};
const avatar_factory=(name, family, patronymic, phone_number, avatar, birth_date, additional)=>{
  return {
    name, family, patronymic, phone_number, avatar, birth_date, additional,
  };
};
export default {

  namespaced: true,
  state     : {
    user: {
      available_annual_certificates: [],
    },
    image_error  : '',
    error_message: '',
  },
  getters: {
    user                         : ({user}) => user,
    additional                   : ({user}) => user.additional,
    user_name                    : (user) => user.user.name,
    user_family                  : (user) => user.user.family,
    user_patronymic              : (user) => user.user.patronymic,
    user_avatar                  : ({user}) => user.avatar,
    user_role                    : ({user}) => user.role,
    user_birthday                : ({user}) => user.birth_date,
    user_phone                   : ({user}) => user.phone_number,
    user_id                      : ({user}) => user.id,
    company_id                   : ({user}) => user.company_id,
    image_error                  : ({image_error}) => image_error,
    error_message                : ({error_message}) => error_message,
    available_annual_certificates: ({user: {available_annual_certificates}}) => {
      return available_annual_certificates.map(({issue_year, url, id}) => {
        return {
          'id'  : id,
          'name': i18n.t('Сертификат за {year} год', {
            'year': issue_year,
          }),
          'url': url,
        };
      });
    },
  },
  mutations: {
    REPLACE_USER_PROFILE(state, value) {
      state.user = value;
    },
    SET_USER_PHONE(state, value) {
      state.user.phone_number = value;
    },
    SET_USER_AVATAR(state, value) {
      state.user.avatar = value;
    },
    SET_USER_NAME(state, value) {
      state.user.name = value;
    },
    SET_USER_FAMILY(state, value) {
      state.user.family = value;
    },
    SET_USER_PATRONIMY(state, value) {
      state.user.patronymic = value;
    },
    SET_USER_ADDITIONAL(state, value) {
      state.user.additional = value;
    },
    SET_BIRTHDAY(state, value) {
      let res;
      if (value) {
        res = value;
        // res = new dayjs(parseInt(value)).utc().format('DD.MM.YYYY');
      } else {
        res = '';
      }
      // state.user.birth_date = new Date(value).toISOString().substring(0, 10);
      state.user.birth_date = res;
    },
    SPEND_POINTS(state, points) {
      state.user.points = points;
      const user = JSON.parse(localStorage.getItem('user'));
      user.points = state.user.points;
      localStorage.setItem('user', JSON.stringify(user));
    },
    IMAGE_ERROR(state, value) {
      state.image_error = value;
    },
    SET_ERROR(state, err) {
      state.error_message = err;
    },
  },
  actions: {
    async post_avatar({commit}, obj) {
      const {user, result} = obj;

      commit('SET_USER_AVATAR', result);
      const {id, name, family, patronymic, phone_number, avatar, birth_date, additional} = user;
      const updated_user = avatar_factory(name, family, patronymic, phone_number, avatar, birth_date, additional);

      try {
        await api.user.save_user_info(id, updated_user);
        commit('IMAGE_ERROR', false);
      } catch (err) {
        console.log(err);
        commit('IMAGE_ERROR', err.message);
      }
    },
    async save_user_info({}, i) {
      const {id, st, own} = i;
      let updated_user;

      if (!!own) {
        updated_user = user_factory(st.name, st.family, st.patronymic, st.phone_number, st.birth_date, st.additional);
      } else {
        updated_user = st;
      }

      let user = JSON.parse(localStorage.getItem('user'));
      for (let key in updated_user) {
        if (key in user) {
          user[key] = updated_user[key];
        }
      }

      localStorage.setItem('user', JSON.stringify(user));

      try {
        await api.user.save_user_info(id, updated_user);
      } catch (err) {
        console.error(err);
      }
    },
    async login({state}) {
      try {
        await api.user.login(state.login, state.password);
      } catch (err) {
        console.error(err);
      }
    },
    async user_profile({}) {
      try {
        await api.user.load_user(this.state.autorisation.user_id);
      } catch (err) {
        console.error(err);
      }
    },
    async change_pass({commit}, obj) {
      try {
        await api.user.change_pass(obj);
        commit('SET_ERROR', '');
        commit('profile/modals/CLOSE_MODAL', 'change_password', {root: true});
      } catch (err) {
        console.error(err);
        if (err.message.indexOf('400')!=-1) {
          commit('SET_ERROR', 'Ошибка в старом пароле');
        }
      }
    },
    replace({commit}, value) {
      if (value) {
        localStorage.setItem('user', JSON.stringify(value));
      }
      commit('REPLACE_USER_PROFILE', JSON.parse(localStorage.getItem('user')));
    },
  },
};

